var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"play-badge",class:[
    ("play-badge--" + _vm.variant),
    ("play-badge--" + _vm.size),
    { 'play-badge--soft': _vm.soft, 'play-badge--pill': _vm.pill } ]},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.icon)?_c('span',{staticClass:"play-badge__icon"},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }